import { render, staticRenderFns } from "./item-movements.vue?vue&type=template&id=7968e068&scoped=true"
import script from "./item-movements.vue?vue&type=script&lang=js"
export * from "./item-movements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7968e068",
  null
  
)

export default component.exports